import { render, staticRenderFns } from "./entity-choice-modal.vue?vue&type=template&id=22570a74&scoped=true"
import script from "./entity-choice-modal.vue?vue&type=script&lang=js"
export * from "./entity-choice-modal.vue?vue&type=script&lang=js"
import style0 from "./entity-choice-modal.vue?vue&type=style&index=0&id=22570a74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22570a74",
  null
  
)

export default component.exports